module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_reset_white.029d7577.svg";